import React, { useRef, useState, useCallback, useEffect } from 'react';
import { useField } from '@unform/core';
import {
  InputLabel,
  Checkbox,
  Radio as RadioMaterialUI,
  RadioGroup,
  FormControlLabel,
  FormLabel,
} from '@material-ui/core';

interface RadioProps {
  name: string;
  valor: string[];
  label: string[];
  title: string;
}
const Radio: React.FC<RadioProps> = ({
  name,
  label,
  valor,
  title,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState(valor[0]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setValue((event.target as HTMLInputElement).value);
  };
  const { fieldName, defaultValue, error, registerField } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [registerField, fieldName]);

  return (
    <div>
      <FormLabel component="legend">{title}</FormLabel>
      <RadioGroup
        aria-label="gender"
        name="gender1"
        value={value}
        onChange={handleChange}
      >
        {label.map((lab, idx) => (
          <FormControlLabel
            key={valor[idx]}
            value={valor[idx]}
            inputRef={inputRef}
            control={<RadioMaterialUI />}
            label={lab}
          />
        ))}
      </RadioGroup>
    </div>
  );
};

export default Radio;
